import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import { withFirebase } from './Firebase';

class ForgotPasswordBase extends Component {

    constructor(props) {
        super(props);

        this.state = {
            email: '',
            passwordResetSuccess: false,
            error: null
        };

        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    onChange(event) {
        this.setState({ [event.target.name]: event.target.value });
    };

    onSubmit(event) {
        const { email } = this.state;
        event.preventDefault();

        this.props.firebase
            .passwordReset(email)
            .then(authUser => {
                this.setState({ email: '', error: null, passwordResetSuccess: true });
            })
            .catch(error => {
                this.setState({ error });
            });

    };

    render() {
        const isInvalid =
            this.state.email === '';

        return (
            <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
                <div className="sm:mx-auto sm:w-full sm:max-w-md">
                    <img className="mx-auto h-12 w-auto" src="images/LogoSmallText.png" alt="Alerion Art" />
                    <h2 className="mt-6 text-center text-3xl leading-9 font-extrabold text-gray-900">
                        Forgot Password?
                    </h2>
                    { this.state.passwordResetSuccess && 
                        <div className="shadow rounded-md bg-green-100 p-4 mt-4">
                            <div className="flex">
                                <div className="flex-shrink-0">
                                    <svg className="h-5 w-5 text-green-400" viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                    </svg>
                                </div>
                                <div className="ml-3">
                                    <h3 className="text-sm leading-5 font-medium text-green-800">
                                        Password Reset
                                    </h3>
                                    <div className="mt-2 text-sm leading-5 text-green-700">
                                        <p>
                                            A reset password email has been sent to you. After you reset your password, <Link to="/login">Login Here</Link>.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    { this.state.error && 
                        <div className="shadow rounded-md bg-red-100 p-4 mt-4">
                            <div className="flex">
                                <div className="flex-shrink-0">
                                <svg class="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/>
                                </svg>
                                </div>
                                <div className="ml-3">
                                    <h3 className="text-sm leading-5 font-medium text-red-800">
                                        Whoops
                                    </h3>
                                    <div className="mt-2 text-sm leading-5 text-red-700">
                                        <p>
                                            {this.state.error.message}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>

                <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
                    <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
                        <form onSubmit={this.onSubmit}>
                            <div>
                                <label htmlFor="email" className="block text-sm font-medium leading-5 text-gray-700">
                                    Email address
                                </label>
                                <div className="mt-1 rounded-md shadow-sm">
                                    <input id="email"
                                        type="email"
                                        name="email"
                                        value={this.state.email}
                                        onChange={this.onChange}
                                        required
                                        placeholder="me@domain.com"
                                        className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5" />
                                </div>
                            </div>

                            <div className="mt-6">
                                <span className="block w-full rounded-md shadow-sm">
                                    <button
                                        type="submit"
                                        disabled={isInvalid}
                                        className="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out">
                                        Submit
                                    </button>
                                </span>
                            </div>
                        </form>

                    </div>
                </div>
            </div>
        );
    }
}

const ForgotPassword = withFirebase(ForgotPasswordBase);

export default ForgotPassword;